<div class="expire-contract-box box" data-testid="contract-expiring-list">
    <div class="box-header">
        <div class="box-header-flex">
            <h4>{{ "overview.expiring_contracts" | translate }}</h4>
            <app-aw-tooltip [tooltipTitle]="'overview.expiring_contracts' | translate">
                <ng-container description>
                    {{ "overview.performance_tooltip" | translate }}
                </ng-container>
            </app-aw-tooltip>
        </div>

        @if (!sidebarService.isBelowMobileWidth()) {
            <p class="pointer" (click)="onLinkClick()" [routerLink]="['/contracts']" data-testid="contract-expiring-list-open-list-link">
                <u>{{ "overview.open_list" | translate }}</u>
                <img src="assets/icons/arrow-up-blue.svg" style="transform: rotate(90deg)" alt="{{ 'customers.company_name' | translate }}" />
            </p>
        }
    </div>
    @if (!loading()) {
        <div style="position: relative">
            @if (contracts()[0] === "") {
                <div class="empty-performance-overlay">
                    <p>{{ "overview.no_expiring_contracts" | translate }}</p>
                </div>
            }
            <table style="width: 100%">
                <tr>
                    <th class="smaller-column" data-testid="contract-expiring-list-header-contract-id">{{ "operator.contract_modal.contract_id" | translate }}</th>
                    <th class="locations-column" data-testid="contract-expiring-list-header-locations">{{ "misc.locations" | translate }}</th>
                    <th class="smaller-column overflow-column" data-testid="contract-expiring-list-header-expiration-date">{{ "overview.expiration_date" | translate }}</th>
                </tr>
                <tbody>
                    @for (contract of contracts(); track $index) {
                        <tr [attr.data-testid]="'contract-expiring-list-row-' + contract.contract_key">
                            <td
                                [routerLink]="['/contracts']"
                                [queryParams]="{ id: contract.contract_key }"
                                class="pointer smaller-column overflow-column"
                                [attr.data-testid]="'contract-expiring-list-row-' + contract.contract_key + '-open-link'"
                            >
                                <u>{{ contract.contract_id }}</u>
                            </td>
                            <td class="locations-column" data-testid="locations-cell">{{ contract.location_names ? contract.location_names.join(", ") : "" }}</td>
                            <td class="smaller-column" data-testid="expiration-date-cell">
                                <strong [style]="isExpiring(contract.end_date) ? 'color: #D81E5B;' : isSemiExpiring(contract.end_date) ? 'color: #FC9124;' : ''">{{ getPeriod(contract.end_date) }}&ensp;</strong>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    }
    @if (sidebarService.isBelowMobileWidth()) {
        <p class="pointer bottom-link" [routerLink]="['/contracts']" data-testid="contract-expiring-list-open-list-mobile-link">
            <u>{{ "overview.open_list" | translate }}</u>
            <img src="assets/icons/arrow-up-blue.svg" style="transform: rotate(90deg)" alt="{{ 'customers.company_name' | translate }}" />
        </p>
    }
    @if (loading()) {
        <div class="loading-box">
            <app-loading-indicator [size]="'large'" [color]="'secondary'"></app-loading-indicator>
        </div>
    }
</div>
